<template>
  <nav class="nav_center2" style="padding: 0; background: cadetblue">
    <ul style="list-style: none">
      <li :class="{ topmenuactive: activeTab === 'hethongcnttdanang' }" @click="changeTab('hethongcnttdanang')">
        <a id="urlhethongcnttdanang" href="vi/chuongtrinhtaitroxathidiem#danang/hethongcnttdanang" style="color: white;">{{ currentLanguage.header_text_hethongCNTT15 }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xadailoc' }" @click="changeTab('Xadailoc')">
        <a id="urlXadailoc" href="vi/chuongtrinhtaitroxathidiem#danang/xadailoc" style="color: white;"> {{ currentLanguage.header_text_DaiLoc }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xaphuthuan' }" @click="changeTab('Xaphuthuan')">
        <a id="urlXaphuthuan" href="vi/chuongtrinhtaitroxathidiem#danang/xaphuthuan" style="color: white;"> {{ currentLanguage.header_text_PhuThuan }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xavugia' }" @click="changeTab('Xavugia')">
        <a id="urlXavugia" href="vi/chuongtrinhtaitroxathidiem#danang/xavugia" style="color: white;"> {{ currentLanguage.header_text_VuGia }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xahanha' }" @click="changeTab('Xahanha')">
        <a id="urlXahanha" href="vi/chuongtrinhtaitroxathidiem#danang/xahanha" style="color: white;"> {{ currentLanguage.header_text_HaNha }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xathuongduc' }" @click="changeTab('Xathuongduc')">
        <a id="urlXathuongduc" href="vi/chuongtrinhtaitroxathidiem#danang/xathuongduc" style="color: white;"> {{ currentLanguage.header_text_ThuongDuc }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xathanhmy' }" @click="changeTab('Xathanhmy')">
        <a id="urlXathanhmy" href="vi/chuongtrinhtaitroxathidiem#danang/xathanhmy" style="color: white;">  {{ currentLanguage.header_text_ThanhMy }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xadienbantay' }" @click="changeTab('Xadienbantay')">
        <a id="urlXadienbantay" href="vi/chuongtrinhtaitroxathidiem#danang/xadienbantay" style="color: white;"> {{ currentLanguage.header_text_DienBanTay }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xagonoi' }" @click="changeTab('Xagonoi')">
        <a id="urlXagonoi" href="vi/chuongtrinhtaitroxathidiem#danang/xagonoi" style="color: white;"> {{ currentLanguage.header_text_GoNoi }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xabanna' }" @click="changeTab('Xabanna')">
        <a id="urlXabanna" href="vi/chuongtrinhtaitroxathidiem#danang/xabanna" style="color: white;">   {{ currentLanguage.header_text_BaNa }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xahoavang' }" @click="changeTab('Xahoavang')">
        <a id="urlXahoavang" href="vi/chuongtrinhtaitroxathidiem#danang/xahoavang" style="color: white;">{{ currentLanguage.header_text_HoaVang }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xahoatien' }" @click="changeTab('Xahoatien')">
        <a id="urlXahoatien" href="vi/chuongtrinhtaitroxathidiem#danang/xahoatien" style="color: white;"> {{ currentLanguage.header_text_HoaTien }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xathubon' }" @click="changeTab('Xathubon')">
        <a id="urlXathubon" href="vi/chuongtrinhtaitroxathidiem#danang/xathubon" style="color: white;"> {{ currentLanguage.header_text_ThuBon }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xaduyxuyen' }" @click="changeTab('Xaduyxuyen')">
        <a id="urlXaduyxuyen" href="vi/chuongtrinhtaitroxathidiem#danang/xaduyxuyen" style="color: white;"> {{ currentLanguage.header_text_DuyXuyen }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xanamphuoc' }" @click="changeTab('Xanamphuoc')">
        <a id="urlXanamphuoc" href="vi/chuongtrinhtaitroxathidiem#danang/xanamphuoc" style="color: white;">  {{ currentLanguage.header_text_NamPhuoc }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xaxuanphu' }" @click="changeTab('Xaxuanphu')">
        <a id="urlXaxuanphu" href="vi/chuongtrinhtaitroxathidiem#danang/xaxuanphu" style="color: white;"> {{ currentLanguage.header_text_XuanPhu }}</a>
      </li>
      <li :class="{ topmenuactive: activeTab === 'Xaduynghia' }" @click="changeTab('Xaduynghia')">
        <a id="urlXaduynghia" href="vi/chuongtrinhtaitroxathidiem#danang/xaduynghia" style="color: white;">{{ currentLanguage.header_text_DuyNghia }}</a>
      </li>
    </ul>
  </nav>

  <div class="wrapper row3">
     <main class="hoc container-fluid clear bv p-0">

      <!-- Mỗi xã -->
      <div v-if="activeTab === 'hethongcnttdanang'" style="min-height: 500px" class="padding-top15">
        <div class="title-bai-viet" v-html="titleHtmlHethongcnttdanang"></div>
        <div v-html="contentHtmlHethongcnttdanang"></div>
        </div>
      <div v-if="showXadailoc" class="padding-top15"><strong>Đại Lộc</strong><div v-html="contentHtmlXadailoc"></div></div>
      <div v-if="showXaphuthuan" class="padding-top15"><strong>Phú Thuận</strong><div v-html="contentHtmlXaphuthuan"></div></div>
      <div v-if="showXavugia" class="padding-top15"><strong>Vu Gia</strong><div v-html="contentHtmlXavugia"></div></div>
      <div v-if="showXahanha" class="padding-top15"><strong>Hà Nha</strong><div v-html="contentHtmlXahanha"></div></div>
      <div v-if="showXathuongduc" class="padding-top15"><strong>Thượng Đức</strong><div v-html="contentHtmlXathuongduc"></div></div>
      <div v-if="showXathanhmy" class="padding-top15"><strong>Thạnh Mỹ</strong><div v-html="contentHtmlXathanhmy"></div></div>
      <div v-if="showXadienbantay" class="padding-top15"><strong>Điện Bàn Tây</strong><div v-html="contentHtmlXadienbantay || 'Đang cập nhật...'"></div></div>
      <div v-if="showXagonoi" class="padding-top15"><strong>Gò Nổi</strong><div v-html="contentHtmlXagonoi || 'Đang cập nhật...'"></div></div>
      <div v-if="showXabanna" class="padding-top15"><div v-html="contentHtmlXabanna || 'Đang cập nhật...'"> </div></div>
      <div v-if="showXahoavang" class="padding-top15"><div v-html="contentHtmlXahoavang || 'Đang cập nhật...'"> </div></div>
      <div v-if="showXahoatien" class="padding-top15"><div v-html="contentHtmlXahoatien || 'Đang cập nhật...'"> </div></div>
      <div v-if="showXathubon" class="padding-top15"><div v-html="contentHtmlXathubon || 'Đang cập nhật...'"> </div></div>
      <div v-if="showXaduyxuyen" class="padding-top15"><div v-html="contentHtmlXaduyxuyen || 'Đang cập nhật...'"> </div></div>
      <div v-if="showXanamphuoc" class="padding-top15"><div v-html="contentHtmlXanamphuoc|| 'Đang cập nhật...'"> </div></div>
      <div v-if="showXaxuanphu" class="padding-top15"><div v-html="contentHtmlXaxuanphu|| 'Đang cập nhật...'"> </div></div>
      <div v-if="showXaduynghia" class="padding-top15"><div v-html="contentHtmlXaduynghia || 'Đang cập nhật...'"> </div></div>

    </main>
  </div>
</template>
<script scoped>
import { languages } from "@/components/languages";
import { apiChiTietBaiViet } from "@/components/listService";
import axios from "axios";


export default {
  components: {

  },
  data() {
    return {
      activeTab: 'hethongcnttdanang',

      currentLanguage: languages.vi,
      lang: "",
      base64: "",
      base64Title: "",

      showXavugia: false,
      showXahanha: false,
      showXaphuthuan: false,
      showCopilot: false,
      showGrok: false,
      showXathuongduc: false,
      showManus: false,
      showXadailoc: false,
      showXadienbantay: false,
      showXathanhmy: false,
      showXagonoi: false,
      showUngDungAI: false,
      showXabanna: false,
      showXahoavang: false,
      showXahoatien: false,
      showXathubon: false,
      showXaduyxuyen: false,
      showXanamphuoc: false,
      showXaxuanphu: false,
      showXaduynghia: false,
      showHethongcnttdanang: false,


      titleHtmlAITaiLopHoc: "",
      contentHtmlAITaiLopHoc: "",
      titleHtml: "",
      contentHtml: "",
      titleHtmlTruongTaiTro: "",
      contentHtmlTruongTaiTro: "",
      titleHtmlTH: "",
      contentHtmlTH: "",
      titleHtmlTHCS: "",
      contentHtmlTHCS: "",
      titleHtmlTHPT: "",
      contentHtmlTHPT: "",
      titleHtmlLienHe: "",
      contentHtmlLienHe: "",
      titleHtmlLienCap: "",
      contentHtmlLienCap: "",
      contentHtmlXathanhmy: "",

      titleHtmlXadailoc: "",
      titleHtmlXavugia: "",
      titleHtmlXahanha: "",
      titleHtmlXaphuthuan: "",
      titleHtmlCopilot: "",
      titleHtmlGrok: "",
      titleHtmlXathuongduc: "",
      titleHtmlXadienbantay: "",
      titleHtmlXagonoi: "",
      titleHtmlManus: "",
      titleHtmlUngDungAI: "",
      titleHtmlXabanna: "",
      titleHtmlXahoavang: "",
      titleHtmlXahoatien: "",
      titleHtmlXathubon: "",
      titleHtmlXaduyxuyen: "",
      titleHtmlXanamphuoc: "",
      titleHtmlXaxuanphu: "",
      titleHtmlXaduynghia: "",
titleHtmlHethongcnttdanang: "",
conttentHtmlHethongcnttdanang: "",

      contentHtmlXadailoc: "",
      contentHtmlXavugia: "",
      contentHtmlXahanha: "",
      contentHtmlCopilot: "",
      contentHtmlXaphuthuan: "",
      contentHtmlGrok: "",
      contentHtmlXathuongduc: "",
      contentHtmlXadienbantay: "",
      contentHtmlXagonoi: "",
      contentHtmlManus: "",
      contentHtmlUngDungAI: "",
      contentHtmlXabanna: "",

      contentHtmlXahoavang: "",
      contentHtmlXahoatien: "",
      contentHtmlXathubon: "",
      contentHtmlXaduyxuyen: "",
      contentHtmlXanamphuoc: "",
      contentHtmlXaxuanphu: "",
      contentHtmlXaduynghia: "",


    };
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.isMenuVisible = false;
    } else {
      this.isMenuVisible = true;
    }
    if (!this.hasMounted) {
      this.hasMounted = true;
      this.lang = localStorage.getItem("languages")   || "vi";
      // this.performPostRequest("1755075075179y5bWE", "Xavugia", this.lang);
document.getElementById("urlhethongcnttdanang").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/hethongcntt");
      document.getElementById("urlXadailoc").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xadailoc");
      document.getElementById("urlXaphuthuan").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xaphuthuan");
      document.getElementById("urlXahanha").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xahanha");
      document.getElementById("urlXavugia").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xavugia");
      document.getElementById("urlXathuongduc").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xathuongduc");
      document.getElementById("urlXathanhmy").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xathanhmy");
      document.getElementById("urlXadienbantay").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xadienbantay");
      document.getElementById("urlXagonoi").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xagonoi");
      document.getElementById("urlXabanna").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xabanna");
      document.getElementById("urlXahoavang").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xahoavang");
      document.getElementById("urlXahoatien").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xahoatien");
      document.getElementById("urlXathubon").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xathubon");
      document.getElementById("urlXaduyxuyen").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xaduyxuyen");
      document.getElementById("urlXanamphuoc").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xanamphuoc");
      document.getElementById("urlXaxuanphu").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xaxuanphu");
      document.getElementById("urlXaduynghia").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/xaduynghia");


      // document.getElementById("urlManus").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/manus/");
      // document.getElementById("urlGrok").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/grok/");
      // document.getElementById("urlCopilot").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#danang/copilot/");




      let fragmentTab = window.location.hash.substring(1);
            if (fragmentTab.endsWith("/")) {
                fragmentTab = fragmentTab.slice(0, -1);
            }
      console.log("fragmentTab " + fragmentTab);

      if (fragmentTab === "danang/xadailoc") {
        this.changeTab("Xadailoc");
      } else if (fragmentTab === "danang/xaphuthuan") {
        this.changeTab("Xaphuthuan");
      } else if (fragmentTab === "danang/xahanha") {
        this.changeTab("Xahanha");
      } else if (fragmentTab === "danang/xavugia") {
        this.changeTab("Xavugia");
      } else if (fragmentTab === "danang/copilot") {
        this.changeTab("Copilot");
      } else if (fragmentTab === "danang/grok") {
        this.changeTab("Grok");
      } else if (fragmentTab === "danang/xathuongduc") {
        this.changeTab("Xathuongduc");
      } else if (fragmentTab === "danang/manus") {
        this.changeTab("Manus");
      }else if (fragmentTab === "danang/xathanhmy") {
        this.changeTab("Xathanhmy");
      
      } else if (fragmentTab === "danang/xadienbantay") {
        this.changeTab("Xadienbantay");

      }   else if (fragmentTab === "danang/xagonoi") {
        this.changeTab("Xagonoi");
      } else if (fragmentTab === "danang/xabanna") {
        this.changeTab("Xabanna");
      } else if (fragmentTab === "danang/xahoavang") {
        this.changeTab("Xahoavang");
      } else if (fragmentTab === "danang/xahoatien") {
        this.changeTab("Xahoatien");
      } else if (fragmentTab === "danang/xathubon") {
        this.changeTab("Xathubon");
      } else if (fragmentTab === "danang/xaduyxuyen") {
        this.changeTab("Xaduyxuyen");
      } else if (fragmentTab === "danang/xanamphuoc") {
        this.changeTab("Xanamphuoc");
      } else if (fragmentTab === "danang/xaxuanphu") {
        this.changeTab("Xaxuanphu");
      } else if (fragmentTab === "danang/xaduynghia") {
        this.changeTab("Xaduynghia");
      }
else if (fragmentTab === "danang/hethongcnttdanang") {
        this.changeTab("hethongcnttdanang");
}
       else {
        // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab gioiThieu
        this.changeTab("hethongcnttdanang");
      }
    }
  },
  created() {
    const savedLanguage = localStorage.getItem("languages");
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      window.location.reload();
    },

    async performPostRequest(id, section) {
      this.lang = localStorage.getItem("languages") || "vi";

      try {
        // Thực hiện POST request
        const response = await axios.post(apiChiTietBaiViet, {
          id: id,
          langId: "0",
        });
        if (this.lang === "vi") {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        } else if (this.lang === "en") {
          this.base64 = response.data.result.content_en;
          this.base64Title = response.data.result.title_en;
        } else if (this.lang === "cn") {
          this.base64 = response.data.result.content_cn;
          this.base64Title = response.data.result.title_cn;
        } else if (this.lang === "kr") {
          this.base64 = response.data.result.content_kr;
          this.base64Title = response.data.result.title_kr;
        }

        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        // Store separately for each section
        if (section === "Xavugia") {
          this.titleHtmlXavugia = decodeURIComponent(escape(title));
          this.contentHtmlXavugia = decodeURIComponent(escape(decodedString));
        } else if (section === "Xahanha") {
          this.titleHtmlXahanha = decodeURIComponent(escape(title));
          this.contentHtmlXahanha = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaphuthuan") {
          this.titleHtmlXaphuthuan = decodeURIComponent(escape(title));
          this.contentHtmlXaphuthuan = decodeURIComponent(escape(decodedString));
        } else if (section === "Copilot") {
          this.titleHtmlCopilot = decodeURIComponent(escape(title));
          this.contentHtmlCopilot = decodeURIComponent(escape(decodedString));
        } else if (section === "Grok") {
          this.titleHtmlGrok = decodeURIComponent(escape(title));
          this.contentHtmlGrok = decodeURIComponent(escape(decodedString));
        } else if (section === "Xathuongduc") {
          this.titleHtmlXathuongduc = decodeURIComponent(escape(title));
          this.contentHtmlXathuongduc = decodeURIComponent(escape(decodedString));
        } else if (section === "Manus") {
          this.titleHtmlManus = decodeURIComponent(escape(title));
          this.contentHtmlManus = decodeURIComponent(escape(decodedString));
        } else if (section === "Xadailoc") {
          this.titleHtmlXadailoc = decodeURIComponent(escape(title));
          this.contentHtmlXadailoc = decodeURIComponent(escape(decodedString));
        }
        else if (section === "Xadienbantay") {
          this.titleHtmlXadienbantay = decodeURIComponent(escape(title));
          this.contentHtmlXadienbantay = decodeURIComponent(escape(decodedString));
        }else
         if (section === "Xathanhmy") {
          this.titleHtmlXathanhmy = decodeURIComponent(escape(title));
          this.contentHtmlXathanhmy = decodeURIComponent(escape(decodedString));
        }
        else if (section === "Xagonoi") {
          this.titleHtmlXagonoi = decodeURIComponent(escape(title));
          this.contentHtmlXagonoi = decodeURIComponent(escape(decodedString));
        }else if (section === "UngDungAI") {
          this.titleHtmlUngDungAI = decodeURIComponent(escape(title));
          this.contentHtmlUngDungAI = decodeURIComponent(escape(decodedString));
        } else if (section === "Xabanna") {
          this.titleHtmlXabanna = decodeURIComponent(escape(title));
          this.contentHtmlXabanna = decodeURIComponent(escape(decodedString));
        } else if (section === "Xahoavang") {
          this.titleHtmlXahoavang = decodeURIComponent(escape(title));
          this.contentHtmlXahoavang = decodeURIComponent(escape(decodedString));
        } else if (section === "Xahoatien") {
          this.titleHtmlXahoatien = decodeURIComponent(escape(title));
          this.contentHtmlXahoatien = decodeURIComponent(escape(decodedString));
        } else if (section === "Xathubon") {
          this.titleHtmlXathubon = decodeURIComponent(escape(title));
          this.contentHtmlXathubon = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaduyxuyen") {
          this.titleHtmlXaduyxuyen = decodeURIComponent(escape(title));
          this.contentHtmlXaduyxuyen = decodeURIComponent(escape(decodedString));
        } else if (section === "Xanamphuoc") {
          this.titleHtmlXanamphuoc = decodeURIComponent(escape(title));
          this.contentHtmlXanamphuoc = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaxuanphu") {
          this.titleHtmlXaxuanphu = decodeURIComponent(escape(title));
          this.contentHtmlXaxuanphu = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaduynghia") {
          this.titleHtmlXaduynghia = decodeURIComponent(escape(title));
          this.contentHtmlXaduynghia = decodeURIComponent(escape(decodedString));
        }else if (section === "hethongcnttdanang") {
          this.titleHtmlHethongcnttdanang = decodeURIComponent(escape(title));
          this.contentHtmlHethongcnttdanang = decodeURIComponent(escape(decodedString));
       
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    changeTab(tab) {
      //   if (window.innerWidth <= 768) {
      //     this.isMenuVisible = false;
      //   }
      this.lang = localStorage.getItem("languages");

      const tabStates = {

        Xavugia: false, Xahanha: false, Xaphuthuan: false, Copilot: false, ungDungAI: false,
        Xadailoc: false, xathuongduc: false, Grok: false, Manus: false, Xadienbantay: false, Xagonoi: false, Xathanhmy: false,
        Xabanna: false, Xahoavang: false, Xahoatien: false, Xathubon: false, Xaduyxuyen: false, Xanamphuoc: false, Xaxuanphu: false, Xaduynghia: false,
        hethongcnttdanang: false, 
      };

      this.performPostRequest(this.getPostId(tab), tab, this.lang);

      tabStates[tab] = true;
      this.activeTab = tab;
      this.showXavugia = tabStates.Xavugia;
      this.showXahanha = tabStates.Xahanha;
      this.showXaphuthuan = tabStates.Xaphuthuan;
      this.showCopilot = tabStates.Copilot;
      this.showGrok = tabStates.Grok;
      this.showXathuongduc = tabStates.Xathuongduc;
      this.showManus = tabStates.Manus;
      this.showXadailoc = tabStates.Xadailoc;
      this.showXadienbantay = tabStates.Xadienbantay;
      this.showXathanhmy = tabStates.Xathanhmy;
      this.showXagonoi = tabStates.Xagonoi;
      this.showUngDungAI = tabStates.UngDungAI;
      this.showXabanna = tabStates.Xabanna;
      this.showXahoavang = tabStates.Xahoavang;
      this.showXahoatien = tabStates.Xahoatien;
      this.showXathubon = tabStates.Xathubon;
      this.showXaduyxuyen = tabStates.Xaduyxuyen;
      this.showXanamphuoc = tabStates.Xanamphuoc;
      this.showXaxuanphu = tabStates.Xaxuanphu;

      this.showXaduynghia = tabStates.Xaduynghia;
      this.showHethongcnttdanang = tabStates.hethongcnttdanang;

    },
    getPostId(tab) {
      // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
      const postIdMap = {

        Xavugia: "1755075075179y5bWE",
        Xahanha: "1755074439803qY9OA",
        Xaphuthuan: "1755075027524GM6lW",
        Copilot: "1739962827008hEz13",
        Grok: "1755075075179y5bWE",
        Xathuongduc: "1755075105100F46nD",
        Manus: "1741754674991tS4fV",
        Xadailoc: "1755075182413WqIsP",
        Xadienbantay: "1757567017935BGWhu", // thay ID sau
        Xagonoi: "1757579887540Ewch4",      // thay ID sau  
        UngDungAI: "",   // thay ID sau
        Xathanhmy: "1757731460387uDMLU", // thay ID sau
        Xabanna: "1757567108889JSa99",   // thay ID sau
        Xahoavang: "1757579979449tQ2q5", // thay ID sau
        Xahoatien: "1757580171687btStP",  // thay ID sau
        Xathubon: "1757567173058MYDpG", //
        Xaduyxuyen: "1757579949560pAli7",    // thay ID sau
        Xanamphuoc: "17575672307837SrWu",     //17575672307837SrWu
        Xaxuanphu: "1757580202709rPP4t",   // thay ID sau
        Xaduynghia: "1757580234831xV46C",    // thay ID sau
        hethongcnttdanang: "1757136627708fRdw2", 
      };

      return postIdMap[tab];
    },
  },
};
</script>

<style scoped>
.title-bai-viet {
  display: none;
}

.hiddentitle {
  display: none;
}
</style>
